import React from 'react';

import AdminTemplate from '../layout/AdminTemplate';
import DashboardV3Page from '~features/dashboard-v3';
import requireAuth from '~components/hocs/requireAuth';

const META_TAGS = {
  title: 'Dashboard - Prerender.io',
};

function DashboardPage() {
  return (
    <AdminTemplate metaTags={META_TAGS}>
      <DashboardV3Page />
    </AdminTemplate>
  );
}

export default requireAuth(DashboardPage);
